import { render, staticRenderFns } from "./ReInputBICUr.vue?vue&type=template&id=5313e0c5&scoped=true"
import script from "./ReInputBICUr.vue?vue&type=script&lang=js"
export * from "./ReInputBICUr.vue?vue&type=script&lang=js"
import style0 from "./ReInputBICUr.vue?vue&type=style&index=0&id=5313e0c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313e0c5",
  null
  
)

export default component.exports